import {useEffect} from "react";
import {useMap} from "react-leaflet";

export default function FlyToLaveuse({selected, telematics, flyKey}) {
    const map = useMap();

    useEffect(() => {
        if (!flyKey) return;
        const live = telematics?.[selected?.id]?.live ?? selected?.live;
        if (live?.latitude != null && live?.longitude != null) {
            map.flyTo([live.latitude, live.longitude], 18, {
                duration: 1.25
            });
        }
    }, [flyKey]);

    return null;
}
